module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a04_toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("CONTENTS")])]), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/09_prf1"
    }
  }, [_c('b', [_vm._v("PREFACE")]), _vm._v(" "), _c('i', [_vm._v("Romain Cansiere")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10_prf2"
    }
  }, [_c('b', [_vm._v("PREFACE")]), _vm._v(" "), _c('i', [_vm._v("Ed Gilbert")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11_fore"
    }
  }, [_c('b', [_vm._v("FOREWORD")]), _vm._v(" "), _c('i', [_vm._v("Edward L. Bale, Jr., Colonel, USMC (Ret)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/12_ch01"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("A NEW DOCTRINE FOR A NEW WAR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/13_ch02"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("SALAD DAYS—FORMATION AND TRAINING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("THE TANKS OF CHARLIE COMPANY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("THE CLOTHES ON THEIR BACKS—CLOTHING AND EQUIPMENT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("OBJECTIVE: CODE NAME HELEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("DAY ONE—THE REEF")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("DAY ONE—INLAND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("DAY TWO—SECURING THE BEACHHEAD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("DAY THREE—SWEEPING THE ISLAND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("DAY FOUR—THE FINAL CARNAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "spacert"
  }, [_c('b', [_vm._v("AFTERMATH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("EPILOGUE:")]), _vm._v(" "), _c('i', [_vm._v("The Legacy of Tarawa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_later",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LATER LIFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_appA",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPENDIX A:")]), _vm._v(" "), _c('i', [_vm._v("Charlie Company Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_appB",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPENDIX B:")]), _vm._v(" "), _c('i', [_vm._v("Tank Company Organization and Equipment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_appC",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPENDIX C:")]), _vm._v(" "), _c('i', [_vm._v("Inside the M4A2 Tank")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_appD",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPENDIX D:")]), _vm._v(" "), _c('i', [_vm._v("Charlie Company Personnel at Tarawa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_appE",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPENDIX E:")]), _vm._v(" "), _c('i', [_vm._v("Historical Research and Photographic Analysis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/29_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("REFERENCES CITED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/06_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a6b413","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_toc.vue
// module id = 69
// module chunks = 0